export enum ToastNotificationType {
	WARNING = 'warning',
	SUCCESS = 'success',
}

export interface ToastNotificationAction {
	label: string
	icon?: string
	handler: () => void | Promise<void>
}

export interface ToastNotification {
	id: string;
	title: string;
	message?: string;
	highlight?: string;
	type: ToastNotificationType;
	action?: ToastNotificationAction;
}
